import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loading2",
  "use": "icon-loading2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-loading2\"><path d=\"M512 272a240 240 0 1 0 0 480 240 240 0 0 0 0-480zM112 512a400 400 0 1 1 800 0 400 400 0 0 1-800 0z\" opacity=\".3\" p-id=\"6196\" /><path d=\"M512 272A240 240 0 1 0 752 512h160A400 400 0 1 1 512 112v160z\" p-id=\"6197\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol